module.exports = __webpack_public_path__ + "img/tittle.d328e05b.png";